// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DaOM","title":"styles_title__NjzKf"};